<template>
  <div class="div-middle-all" id="contactDiv">
    <div class="title-sy"><span style="border-bottom: 1px solid rgb(124, 185, 186);">联系我们</span></div>
    <el-form ref="form" :rules="formRules" :model="formData" :inline-message="true">
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名" :label-width="labelWidth" prop="name">
            <el-input v-model="formData.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号码" :label-width="labelWidth" prop="phone">
            <el-input v-model="formData.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目城市" :label-width="labelWidth" prop="city">
            <el-input v-model="formData.city" placeholder="请项目城市"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="意向品牌" :label-width="labelWidth" prop="brand">
            <el-input v-model="formData.brand" placeholder="请输入意向品牌"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="建筑面积/m²" :label-width="labelWidth" prop="area">
            <el-input v-model="formData.area" placeholder="请输入建筑面积"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮箱" :label-width="labelWidth" prop="email">
            <el-input v-model="formData.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item style="margin-top: 35px">
          <el-button type="info" @click="submit('form')" class="btn-sy">提交</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "ContactPlugin",
  data() {
    return {
      labelWidth: '30%',
      formData: {
        name: '',
        phone: '',
        city: '',
        brand: '',
        area: '',
        email: '',
      },
      formRules: {
        name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            {min: 2, max: 5, message: '长度在 2 到 5 个字符'},
            {pattern: /^[\u4E00-\u9FA5]+$/, message: '用户名只能为中文'}
        ],
        phone: [
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {validator: function(rule,value,callback){
                if(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(value) == false){
                  callback(new Error("请输入正确的手机号"));
                }else{
                  callback();
                }
              }, trigger: 'blur'}
        ],
        city: [{required: true, message: '请输入项目城市', trigger: 'blur'}],
        brand: [{required: true, message: '请输入意向品牌', trigger: 'blur'}],
        area: [{required: true, message: '请输入建筑面积', trigger: 'blur'}]
      }
    }
  },
  methods: {
    submit(formName) {
      console.log(this.formData)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formData.email && !this.validEmail(this.formData.email)) {
            this.$message({
              showClose: true,
              message: '请输入正确的邮箱',
              type: 'error'
            });
          }
          this.$http({
            url: '/contact/insert',
            method: 'POST',
            data: {
              cusName: this.formData.name,
              mobile: this.formData.phone,
              pjCity: this.formData.city,
              brandName: this.formData.brand,
              area: this.formData.area,
              email: this.formData.email,
            }
          }).then(res => {
            if (res.status == '200') {
              this.$message({
                showClose: true,
                message: '提交成功',
                type: 'success'
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    validEmail(val) {
      const reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      return reg.test(val);
    }
  }
}
</script>

<style scoped>
  .title-sy {
    padding: 20px;
    font-size: 20px;
    font-weight: 550;
  }
  .btn-sy {
    width: 260px;
    background: black;
  }
  #contactDiv >>> .el-form-item__error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }
</style>
